import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/poi/bulk/onboarding/upload_info", payload);
  },
};
